import React from 'react'
import { Link } from 'react-router-dom'
import { Outlet } from 'react-router-dom'
import { useTheme } from '@/components/ThemeProvider'

export const Content = ({ children }) => {
  return (
    <div className={`flex flex-col flex-grow h-screen mt-20`}>
      {children}
    </div>
  )
}

export const ContentCenter = ({ children }) => {
  return (
    <div className={`flex flex-col justify-center items-center min-h-full h-full overflow-y-scroll`}>
      {children}
    </div>
  )
}

export const Logo = () => {
  const { resolvedTheme } = useTheme()

  return (
    <div className="absolute top-0 left-0 right-0 w-full flex justify-between items-center p-3 z-10 hover:cursor-pointer">
      <Link to="/" className="flex justify-start p-2">
        <Choose>
          <When condition={resolvedTheme === 'dark'}>
            <img
              className='h-12 w-auto'
              src='/logo.svg'
              alt='Mindjoy logo'
            />
          </When>
          <Otherwise>
            <img
              className='h-12 w-auto'
              src='/mindjoy-logo.svg'
              alt='Mindjoy logo'
            />
          </Otherwise>
        </Choose>
      </Link>
    </div>

  )
}

export const FullLayout = () => {

  return (
    <div className="flex flex-col min-h-full w-full">
      <Outlet />
    </div>
  )
}

FullLayout.Content = Content
FullLayout.Logo = Logo
FullLayout.ContentCenter = ContentCenter

export default FullLayout
